"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createPerformanceObserver = require("../utilities/createPerformanceObserver");

var _performance = require("../utilities/performance");

var _getFirstHiddenTime = _interopRequireDefault(require("../utilities/getFirstHiddenTime"));

/**
 * A plugin responsible for collecting paint metrics exposed by the
 * [Paint Timing][1] specification.
 *
 * This plugin adds the following parameters to the beacon:
 *
 * - `firstPaint`: the exact time taken for the browser to render anything as
 *   visually different from what was on the screen before navigation, e.g. a
 *   background change after a long blank white screen time.
 *
 * - `firstContentfulPaint`: time taken for the browser to render the first bit
 *   of content from the DOM, which can be anything from an important image,
 *   text, or even the small SVG at the bottom of the page.
 *
 * [1]: https://www.w3.org/TR/paint-timing/
 */
var createPaintTimingPlugin = function createPaintTimingPlugin() {
  return function (_ref) {
    var addVariable = _ref.addVariable,
        sendBeacon = _ref.sendBeacon;
    var observer;
    var didReceiveFirstPaint = false;
    var didReceiveFirstContentfulPaint = false;

    try {
      observer = (0, _createPerformanceObserver.createPerformanceObserver)(_performance.EntryType.PAINT, function (entry) {
        if (entry.name === _performance.EntryName.FIRST_PAINT) {
          didReceiveFirstPaint = true;

          if (entry.startTime < (0, _getFirstHiddenTime.default)()) {
            addVariable('firstPaint', entry.startTime, true);
            sendBeacon();
          }
        }

        if (entry.name === _performance.EntryName.FIRST_CONTENTFUL_PAINT) {
          didReceiveFirstContentfulPaint = true;

          if (entry.startTime < (0, _getFirstHiddenTime.default)()) {
            addVariable('firstContentfulPaint', entry.startTime, true);
            sendBeacon();
          }
        }

        if (didReceiveFirstPaint && didReceiveFirstContentfulPaint) {
          if (observer != null) {
            observer.disconnect();
          }
        }
      });
    } catch (error) {// Do nothing
    }
  };
};

var _default = createPaintTimingPlugin;
exports.default = _default;